import { useAuth, useBasic } from 'contexts';
import { useCallback, useEffect, useState } from 'react';
import AccessReportsPage from './Access';
import CoursesReportsPage from './Courses';
import EmailsReportsPage from './Emails';
import RankingReportsPage from './Ranking';
import './style.scss';

export default function ReportsPage() {
  const { appearance } = useBasic();
  const { profileUser } = useAuth();
  const [activeTab, setActiveTab] = useState('courses');
  const [show, setShow] = useState(false);

  const isMenuActive = useCallback(
    (pathname: string) => {
      if (appearance?.menu && Object.keys(appearance?.menu as any).includes(pathname)) {
        return (appearance?.menu as any)[pathname];
      }
      return true;
    },
    [appearance],
  );

  useEffect(() => {
    if (profileUser) {
      if (profileUser?.roles?.includes('admin') === false) {
        window.location.href = '/';
      } else if (!isMenuActive('reports')) {
        window.location.href = '/';
      } else {
        setShow(true);
      }
    }
  }, [isMenuActive, profileUser]);

  return (
    <section id="settings">
      {show && (
        <div>
          <h2 className="text-xl lg:text-3xl mb-5 lg:mb-8">Relatórios</h2>

          <div className="tabs mb-4">
            <button className={`tab ${activeTab === 'courses' ? 'active' : ''}`} onClick={() => setActiveTab('courses')}>
              Cursos Concluídos
            </button>
            <button className={`tab ${activeTab === 'ranking' ? 'active' : ''}`} onClick={() => setActiveTab('ranking')}>
              Ranking
            </button>
            <button className={`tab ${activeTab === 'access' ? 'active' : ''}`} onClick={() => setActiveTab('access')}>
              Acessos
            </button>
            <button className={`tab ${activeTab === 'emails' ? 'active' : ''}`} onClick={() => setActiveTab('emails')}>
              E-mails
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 'courses' && <CoursesReportsPage />}
            {activeTab === 'ranking' && <RankingReportsPage />}
            {activeTab === 'access' && <AccessReportsPage />}
            {activeTab === 'emails' && <EmailsReportsPage />}
          </div>
        </div>
      )}
    </section>
  );
}
